import type { FindOperationLogItemsInput } from '@travel-planner/shared/schemas/operation-log';
import { trpc } from '@/shared/api/trpc';

type Options = {
  enabled?: boolean;
};

// Item options for the Change Logs "Item" filter. Cheap and stable relative to
// the log list itself — a short staleTime keeps the dropdown from re-fetching
// on every page/filter change while still picking up newly-touched items.
export const useOperationLogItemsData = (
  input: FindOperationLogItemsInput,
  options?: Options
) =>
  trpc.operationLog.findItemsByItinerary.useQuery(input, {
    enabled: options?.enabled ?? true,
    staleTime: 30_000,
  });
